import '@styles/Radio/style.css'
import React from 'react'
import Typography from '../Typography'

export interface IRadioProps {
  label?: string
  name: string
  id: string
  checked?: boolean
  onRadioButtonClick?: (ev: any) => void
  variant?: any
  classes?: any
  disabled?: boolean
}

const RadioButton: React.FC<IRadioProps> = ({
  label,
  name,
  id,
  checked,
  onRadioButtonClick,
  variant,
  classes,
  disabled
}) => {
  return (
    <label className='container'>
      {label && (
        <Typography
          classes={classes}
          variant={variant ?? 'list'}
          color='primary'
          disabled={disabled}
        >
          {label}
        </Typography>
      )}
      <input
        type='radio'
        id={id}
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={onRadioButtonClick}
      />
      <span className='mark'></span>
    </label>
  )
}

export default RadioButton
